import HomeService from "../../services/HomeService";
import Logger from "../../services/Logger";
import JigsawService from "../puzzles/jigsaw/JigsawService";
import SlidingService from "../puzzles/sliding/SlidingService";

function withTimeout(promise, ms) {
    return Promise.race([
        promise,
        new Promise((resolve) => {
            window.setTimeout(() => resolve(null), ms);
        }),
    ]);
}

/**
 * Latest published puzzle of a kind, for how-to example cards.
 * Falls back to null so static sample JSON still works offline.
 */
export async function fetchPublishedHowtoStory(kind, language) {
    try {
        const k = String(kind || "").trim().toUpperCase();
        const live = await withTimeout((async () => {
            if (k === "JIGSAW") {
                const res = await JigsawService.listBrowse({
                    page: 0,
                    pageSize: 1,
                    language,
                });
                const row = Array.isArray(res?.content) ? res.content[0] : null;
                return row?.story && typeof row.story === "object" ? row.story : null;
            }
            if (k === "SLIDING") {
                const res = await SlidingService.listBrowse({
                    page: 0,
                    pageSize: 1,
                    language,
                });
                const row = Array.isArray(res?.content) ? res.content[0] : null;
                return row?.story && typeof row.story === "object" ? row.story : null;
            }
            const res = await HomeService.getHomePuzzlePage({
                page: 0,
                pageSize: 1,
                language,
                kind: k,
                accessFilter: "all",
                excludeCompleted: false,
            });
            const row = Array.isArray(res?.content) ? res.content[0] : null;
            if (!row) return null;
            return row.story && typeof row.story === "object" ? row.story : row;
        })(), 4000);
        return live;
    } catch (error) {
        Logger.error("How-to published example:", error);
        return null;
    }
}
